<template lang="pug">
div
  table.table.table-striped.table-hover
    thead
      tr
        th #
        th Plano
        th Status
        th Válido até
        th.text-center Ações
    tbody
      tr(v-for="subscription in subscriptions.rows")
        td {{subscription.id}}
        td {{subscription.plan.title}}
        td(:class="`${subscription.status}-subscription`") {{subscription.status | subscriptionStatus}}
        td {{subscription.expiresIn | toDate}}
        td
          .actions
            .tooltip.tooltip-left.c-hand(data-tooltip="Visualizar" @click="showSubscription(subscription.id)")
              i.fas.fa-eye
            .tooltip.tooltip-left.c-hand(data-tooltip="Cancelar" v-if="subscription.status === 'active'" @click="cancelSubscription(subscription.id)")
              i.fas.fa-times.text-error
  paginator(v-if="subscriptions && subscriptions.pages > 1" @change-page="onChangePage" :paginated-list="subscriptions")
</template>

<script>
import Paginator from './Paginator'
export default {
  props: {
    subscriptions: { required: true, type: Object },
  },

  components: { Paginator },

  methods: {
    onChangePage(page) {
      this.$emit('change-page', page)
    },

    showSubscription(id) {
      this.$emit('show-subscription', id)
    },

    cancelSubscription(id) {
      this.$emit('cancel-subscription', id)
    },
  },
}
</script>

<style lang="stylus" scoped>
.actions
  display flex
  justify-content space-evenly

.active-subscription
  color #27ae60
.expired-subscription
  color #DBA42A
.canceled-subscription
  color #e24328
</style>
